import React, { useEffect, useState } from "react";
import SideBar from "../Sidebar/SideBar";
import { Icon } from "@iconify/react/dist/iconify.js";
import Swal from "sweetalert2";
import FormDetailsApi from "../../Api/FormDetailsApi";

const initialFormState = {
  FormName: "",
  FormDescription: "",
  FormLink: "",
  CreatedBy: "admin",
  UpdatedBy: "admin",
};

const FormDetails = () => {
  const [itemId, setItemId] = useState("");
  const [formData, setFormData] = useState(initialFormState);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    const response = await FormDetailsApi.GetAllFormDetails();
    if (response?.StatusCode === 200) {
      setData(response.Result || []);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const resetForm = () => {
    setItemId("");
    setFormData(initialFormState);
  };

  const handleSave = async () => {
    if (!String(formData.FormName || "").trim()) {
      await Swal.fire({
        title: "Validation",
        text: "Form Name is required.",
        icon: "warning",
        width: "300px",
      });
      return;
    }

    const response = await FormDetailsApi.CreateFormDetails(formData);
    if (response?.StatusCode === 201) {
      await Swal.fire({
        title: "Saved",
        text: "Form Details created successfully.",
        icon: "success",
        width: "300px",
      });
      resetForm();
      fetchData();
    } else {
      await Swal.fire({
        title: "Error",
        text: response?.ErrorMessages || "Unable to create Form Details.",
        icon: "error",
        width: "300px",
      });
    }
  };

  const handleEdit = (item) => {
    setItemId(item.Id);
    setFormData({
      FormName: item.FormName || "",
      FormDescription: item.FormDescription || "",
      FormLink: item.FormLink || "",
      CreatedBy: item.CreatedBy || "admin",
      UpdatedBy: "admin",
    });
  };

  const handleUpdate = async () => {
    if (!String(formData.FormName || "").trim()) {
      await Swal.fire({
        title: "Validation",
        text: "Form Name is required.",
        icon: "warning",
        width: "300px",
      });
      return;
    }

    const response = await FormDetailsApi.UpdateFormDetails(itemId, formData);
    if (response?.StatusCode === 200) {
      await Swal.fire({
        title: "Updated",
        text: "Form Details updated successfully.",
        icon: "success",
        width: "300px",
      });
      resetForm();
      fetchData();
    } else {
      await Swal.fire({
        title: "Error",
        text: response?.ErrorMessages || "Unable to update Form Details.",
        icon: "error",
        width: "300px",
      });
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to delete this form detail?",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes delete it !!",
      width: "300px",
    });

    if (!result.isConfirmed) return;

    const response = await FormDetailsApi.DeleteFormDetails(id, { DeletedBy: "admin" });
    if (response?.StatusCode === 200) {
      await Swal.fire({
        title: "Deleted",
        text: "Form Detail deleted successfully.",
        icon: "success",
        width: "300px",
      });
      fetchData();
    } else {
      await Swal.fire({
        title: "Error",
        text: response?.ErrorMessages || "Unable to delete Form Detail.",
        icon: "error",
        width: "300px",
      });
    }
  };

  return (
    <div className="Flex-general-client-sidebar">
      <div className="sidebar-gen-width">
        <SideBar />
      </div>
      <div className="Main-general-Client">
        <div className="header-general">
          <h2 className="general-card-title">Form Details</h2>
        </div>
        <div className="control_radius">
          <div className="company_control">
            <div className="stock-im-dep1">
              <div className="input-box-Imo1 input-height2">
                <div className="input-box-mok1">
                  <input
                    className="modify_im_input mode_category1"
                    type="text"
                    name="FormName"
                    value={formData.FormName}
                    onChange={handleChange}
                    required
                  />
                  <label className="modify_p_text2">Form Name</label>
                </div>
              </div>
            </div>
            <div className="stock-im-dep1">
              <div className="input-box-Imo1 input-height2">
                <div className="input-box-mok1">
                  <input
                    className="modify_im_input mode_category1"
                    type="text"
                    name="FormLink"
                    value={formData.FormLink}
                    onChange={handleChange}
                  />
                  <label className="modify_p_text2">Form Link</label>
                </div>
              </div>
            </div>
          </div>

          <div className="company_control">
            <div className="stock-im-dep1" style={{ width: "100%" }}>
              <div className="input-box-Imo1 input-height2">
                <div className="input-box-mok1">
                  <textarea
                    className="modify_im_input mode_category1"
                    name="FormDescription"
                    value={formData.FormDescription}
                    onChange={handleChange}
                    rows={3}
                    style={{ minHeight: "90px" }}
                  />
                  <label className="modify_p_text2">Form Description</label>
                </div>
              </div>
            </div>
          </div>

          <div className="ButtonTabSave">
            {itemId ? (
              <button
                id="SaveBtnMain"
                className="update-button-main-save hovered"
                onClick={handleUpdate}
              >
                Update
              </button>
            ) : (
              <button
                id="SaveBtnMain"
                className="save-button-main-save hovered"
                onClick={handleSave}
              >
                Save
              </button>
            )}
          </div>
        </div>

        <div className="company_info-text-im depart_top">Form Details List</div>
        <div className="control_radius">
          <div className="table-account-manager">
            <table className="table-master-acc">
              <thead className="header-table-account">
                <tr>
                  <th className="table-header-manager ac-sno-wth">S.No</th>
                  <th className="table-header-manager">Form Name</th>
                  <th className="table-header-manager">Form Link</th>
                  <th className="table-header-manager">Actions</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, idx) => (
                  <tr key={item.Id}>
                    <td className="table-data-account ac-sno-wth">{idx + 1}</td>
                    <td className="table-data-account">{item.FormName}</td>
                    <td
                      className="table-data-account"
                      title={item.FormLink}
                      style={{
                        maxWidth: "220px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.FormLink}
                    </td>
                    <td className="table-data-account">
                      <button className="edit-btn-acc" onClick={() => handleEdit(item)}>
                        <Icon icon="lucide:edit" />
                      </button>
                      <button className="delete-btn-acc" onClick={() => handleDelete(item.Id)}>
                        <Icon icon="material-symbols:delete" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormDetails;
